import {
	Button,
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuTrigger,
} from "@monbits/ui";
import { Check, Monitor, Moon, Sun } from "lucide-react";
import { useTheme } from "next-themes";
import * as React from "react";

export function ThemeToggle() {
	const { theme, setTheme, systemTheme } = useTheme();
	const [mounted, setMounted] = React.useState(false);

	React.useEffect(() => {
		setMounted(true);
	}, []);

	if (!mounted) {
		return (
			<Button variant="ghost" size="icon" className="h-9 w-9">
				<Sun className="h-4 w-4" />
			</Button>
		);
	}

	// Determine the actual theme being used
	const resolvedTheme = theme === "system" ? systemTheme : theme;

	// Get the icon to display in the button
	const getButtonIcon = () => {
		if (theme === "system") {
			return <Monitor className="h-4 w-4" />;
		}
		if (resolvedTheme === "dark") {
			return <Moon className="h-4 w-4" />;
		}
		return <Sun className="h-4 w-4" />;
	};

	return (
		<DropdownMenu>
			<DropdownMenuTrigger asChild>
				<Button
					variant="ghost"
					size="icon"
					className="h-9 w-9 hover:bg-accent hover:text-accent-foreground"
				>
					{getButtonIcon()}
					<span className="sr-only">Toggle theme</span>
				</Button>
			</DropdownMenuTrigger>
			<DropdownMenuContent align="end" className="w-40">
				<DropdownMenuItem
					onClick={() => setTheme("light")}
					className="cursor-pointer"
				>
					<Sun className="mr-2 h-4 w-4" />
					<span className="flex-1">Light</span>
					{theme === "light" && <Check className="ml-2 h-4 w-4 text-primary" />}
				</DropdownMenuItem>
				<DropdownMenuItem
					onClick={() => setTheme("dark")}
					className="cursor-pointer"
				>
					<Moon className="mr-2 h-4 w-4" />
					<span className="flex-1">Dark</span>
					{theme === "dark" && <Check className="ml-2 h-4 w-4 text-primary" />}
				</DropdownMenuItem>
				<DropdownMenuItem
					onClick={() => setTheme("system")}
					className="cursor-pointer"
				>
					<Monitor className="mr-2 h-4 w-4" />
					<span className="flex-1">System</span>
					{theme === "system" && (
						<Check className="ml-2 h-4 w-4 text-primary" />
					)}
				</DropdownMenuItem>
			</DropdownMenuContent>
		</DropdownMenu>
	);
}
